import './design/ripple.js';
import './design/menu.js';
import './design/dialog.js';
import './design/tabs.js';
import './design/snackbar.js';
import './design/progress.js';
import './design/slider.js';
import './design/chips.js';
import './design/drawer.js';
import './design/select.js';
import './design/alert.js';
import './design/pagination.js';
import './design/table-sort.js';
import './design/banner.js';
import './design/appbar.js';
import './design/bottom-sheet.js';
import './design/dropzone.js';
import './design/toast.js';
import './design/popover.js';
import './design/textarea.js';
import './design/theme.js';
import './design/overlay.js';
import './design/form-validate.js';

document.addEventListener('DOMContentLoaded', () => {
    const toggle = document.querySelector('.admin-menu-toggle');
    if (!toggle) return;
    toggle.addEventListener('click', () => {
        const open = document.body.classList.toggle('admin-nav-open');
        toggle.setAttribute('aria-expanded', String(open));
    });
});
import './design/avatar.js';
import './design/empty.js';
import './design/stepper.js';
import './design/carousel.js';
import './design/rating.js';
import './design/date-picker.js';
import './design/time-picker.js';
import './design/autocomplete.js';
import './design/tag-input';
import './design/fab-dial';
import './design/nav-rail';
import './design/color-picker';
import './design/tree';
import './design/range-dual';
import './design/table-select';
import './design/appbar-search';
import './home-scroll.js';
import './cookies-consent.js';

console.log('JS Ready');
